import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { DiscoDetailsModule, DiscoFormModule, DynamicReportsModule } from '@app/discoverer/dynamic-reports';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { IntlModule } from '@progress/kendo-angular-intl';
import 'hammerjs';
import { ChatBubbleComponent } from './chat-bubble/chat-bubble.component';
import { HomeComponent } from './home-admin/home.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { DrillOutCustomerHomeComponent } from './drill-out-customer/drill-out-customer-home-component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { GraphQLModule } from '@app/graphql.module';
import { environment } from '@env/environment';
import { SharedModule } from '@app/shared/shared.module';
import { PadDrilloutFormComponent } from './drill-out-filter-form/drill-out-filter-form-component';
import { CustomComponentsModule } from '@app/shared-components/shared-components.module';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { DiscovererWidgetsModule } from "@app/discoverer/core/discoverer.module";

@NgModule({
    declarations: [
        HomeComponent,
        ChatBubbleComponent,
        DrillOutCustomerHomeComponent,
        PadDrilloutFormComponent
    ],
    imports: [
    CommonModule,
    RouterModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatOptionModule,
    ChartsModule,
    FormsModule,
    DynamicReportsModule,
    DiscoFormModule,
    DiscoDetailsModule,
    ReactiveFormsModule,
    IntlModule,
    PDFExportModule,
    GraphQLModule.forRoot(environment.VCH.GraphQlURL, [environment.auth.productKey]),
    CustomComponentsModule,
    DiscovererWidgetsModule
],
    providers: [],
    exports: [
        HomeComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule { }
